import { render, staticRenderFns } from "./realtimeQueryTemplate.vue?vue&type=template&id=2b1afb24&scoped=true"
import script from "./realtimeQueryTemplate.vue?vue&type=script&lang=js"
export * from "./realtimeQueryTemplate.vue?vue&type=script&lang=js"
import style0 from "./realtimeQueryTemplate.vue?vue&type=style&index=0&id=2b1afb24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1afb24",
  null
  
)

export default component.exports